<template>
    <div class="news-list">
        <article v-for="(item, index) in list" :key="index">
            <div class="date">
                <span class="day">{{day(item.created_at.date)}}</span>
                <span class="date">{{date(item.created_at.date)}}</span>
            </div>
            <div class="content" :id="setContentId(index)">
                <p class="lead">{{ item.data.content_lead }}</p>

                <div class="more" v-html="item.data.content"></div>

                <button :id="setButtonId(index)" class="js-toggle-info" @click="readMore(index)">   
                    <span class="material-icons">expand_more</span> Read More                 
                </button>
            </div>
        </article>       
        <button v-if="next" type="button" class="button" @click="loadMore">Load more</button>
    </div>
</template>

<script>
export default {
  props: [
    "url"
  ],

  data () {
    return {  
      links: [],
      list: [],
      next: ""
    }
  },

  mounted(){
      axios.get(this.url).then(response => {          
        this.list = response.data.data
        this.next = response.data.links.next
        
      })
  },

  methods: {
    loadMore () {
      axios.get(this.next).then(response => {
        this.list = this.list.concat(response.data.data)
        this.next = response.data.links.next
      })
    },
    date(val){
        var month = val.substring(5,7);
        var year = val.substring(0,4);
        return this.getMonth(month) + " " + year;
    },

    day(val){        
        return val.substring(8,10);
    },

    getMonth(val){
        switch(val){
            case "01":
                return "Jan"
            case "02":
                return "Feb"
            case "03":
                return "Mar"
            case "04":
                return "Apr"
            case "05":
                return "May"
            case "06":
                return "Jun"
            case "07":
                return "Jul"
            case "08":
                return "Aug"
            case "09":
                return "Sep"
            case "10":
                return "Oct"
            case "11":
                return "Nov"
            case "12":
                return "Dec"            
        }
    },
    readMore(index){                
        if(this.list[index].hasOwnProperty('isOpen')){
            this.list[index].isOpen = !this.list[index].isOpen;
        } else {
            this.list[index].isOpen = true;
        }

        var content = document.getElementById("content"+index);
        content.classList.toggle("open");

        var button = document.getElementById("read_more_btn"+index);      
        button.innerHTML = this.readMoreHtml(index);
      
    },
    readMoreHtml(index){       
        if(!this.list[index].isOpen){
            return '<span class="material-icons">expand_more</span> Read More';
        } else {
            return '<span class="material-icons">expand_less</span> Read Less';
        }        
    },
    setContentId(index){
        return "content"+index;
    },
    setButtonId(index){
        return "read_more_btn"+index;
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/UpdateFeed.vue